<template>
  <b-media
    class="notification-card"
    :class="(!notification.isRead && unReadNotifications!=0) && 'notification-card--active'"
  >
    <template #aside>
      <b-avatar
        size="42"
        :variant="displayNotification.type"
        :src="getAvatar(displayNotification.avatar)"
      />
    </template>
    <div class="media-heading d-flex justify-content-between mb-0">
      <p class="media-heading d-flex align-items-center mb-0">
        <span class="font-weight-bolder">
          {{ displayNotification.title }}
        </span>
        <feather-icon
          v-if="!notification.isRead && unReadNotifications!=0"
          icon="CircleIcon"
          size="8"
          fill="#3D61AD"
          class="ml-1 text-primary"
        />
      </p>
      <div
        v-if="notification.notification.walletShareInviteAction === 'REQUESTED' && notification.notification.invitation.processedAt"
      >
        <b-badge
          v-if="notification.notification.invitation.accepted"
          variant="success"
        >
          Accepted
        </b-badge>
        <b-badge
          v-else
          variant="danger"
        >
          Declined
        </b-badge>
      </div>
      <div v-else>
        <b-badge
          v-if="isInviteRevoked(notification.notification.share.invites.data, notification.notification.invitation.checksum)"
          variant="danger"
        >
          Revoked
        </b-badge>
      </div>
    </div>
    <small class="notification-text">{{ displayNotification.subtitle }}</small>

    <!-- Review Button -->
    <div class="text-right">
      <b-button
        v-if="notification.notification.walletShareInviteAction === 'REQUESTED' && !notification.notification.invitation.processedAt && !isInviteRevoked(notification.notification.share.invites.data, notification.notification.invitation.checksum)"
        size="sm"
        variant="primary"
        @click.stop="EventBus.$emit('notification-action', { modalId: `wallet-share-invite-${notification.notification.invitation.checksum}-modal`, notification })"
      >
        Review
      </b-button>
    </div>
    <div class="text-right">
      <small class="text-mute">
        {{ fromNow(UTCtoLocal(displayNotification.createdAt)) }}
      </small>
    </div>
  </b-media>
</template>
<script>
import {
  BMedia, BAvatar, BButton, BBadge,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import { required } from 'vee-validate/dist/rules'
import EventBus from '@/event-bus'

export default {
  components: {
    BMedia,
    BAvatar,
    BButton,
    BBadge,
  },
  props: {
    notification: {
      type: [Array, Object],
      default: () => {},
    },
    unReadNotifications: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      EventBus,
      required,
      self: getUserData(),
    }
  },
  computed: {
    displayNotification() {
      const {
        notification, isRead, uuid, createdAt,
      } = this.notification

      const {
        creator, share, walletShareInviteAction, invitation,
      } = notification

      let title = ''
      let subtitle = ''
      let type = 'light-primary'
      const icon = 'ShareIcon'

      if (walletShareInviteAction === 'REQUESTED') {
        title = 'Account Share Invitation!'
        subtitle = `${creator.name} wants to share '${share.description}' with ${invitation.shareDirection === 'BOTH' ? 'inbound and outbound' : invitation.shareDirection.toLowerCase()} rights with you.'`
        // eslint-disable-next-line no-nested-ternary
        if (invitation.processedAt) type = invitation.accepted ? 'light-success' : 'light-danger'
      } else if (walletShareInviteAction === 'APPROVED') {
        title = 'Account Share Accepted!'
        subtitle = `${creator.uuid === this.self.uuid ? 'You have' : `${creator.name} has`} accepted the invitation for sharing of '${share.description}'.`
        type = 'light-success'
      } else {
        title = 'Account Share Declined!'
        subtitle = `${creator.uuid === this.self.uuid ? 'You have' : `${creator.name} has`} declined the invitation for sharing of '${share.description}'.`
        type = 'light-danger'
      }

      return {
        title, subtitle, type, icon, avatar: creator.avatar, isRead, uuid, createdAt,
      }
    },
  },
  methods: {
    isInviteRevoked(invites, checksum) {
      return invites.find(invite => invite.checksum === checksum).isInvalid
    },
  },
}
</script>
